module.exports = __webpack_public_path__ + "img/karenaraya.3630c782.jpg";